import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {userLoginOIDC, fetchUser} from "modules/actions";
import {isLoggedIn, getUser} from "modules/selectors";
import LoadingSpinner from "components/AppLoading";
import styled from "styled-components";
import {useHistory} from "react-router-dom";
import {OFF_SEASON_ENABLED} from "modules/utils";
import {REDIRECT_URL} from "modules/utils/user";

const PreloaderContainer = styled.div`
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const SECRET_COUNT = 10;
const SECRET_KEY_ENABLED = JSON.parse(
	process.env.REACT_APP_SECRET_KEY || "false"
);

const STORAGE_SECRET_COUNT = SECRET_KEY_ENABLED
	? Number(localStorage.getItem("secret_count"))
	: SECRET_COUNT;

export const FetchUserOIDC: React.FC = ({children}) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const code = new URLSearchParams(window.location.search).get("code");
	const is_logged_in = useSelector(isLoggedIn);
	const user = useSelector(getUser);
	const [is_ready, setIsReady] = useState(false);
	const is_secret_key_enabled =
		!is_logged_in && STORAGE_SECRET_COUNT < SECRET_COUNT;
	const is_off_season_with_secret_key_enabled =
		is_secret_key_enabled && OFF_SEASON_ENABLED;

	useEffect(() => {
		const paramsWithoutCode = new URLSearchParams(window.location.search);
		paramsWithoutCode.delete("code");
		const searchString = paramsWithoutCode.toString().length
			? "?" + paramsWithoutCode.toString()
			: "";
		window.history.replaceState(
			null,
			"",
			window.location.pathname + searchString
		);

		if (is_logged_in) {
			dispatch(fetchUser());
			return;
		}

		if (!code || is_logged_in) {
			return;
		}

		dispatch(
			userLoginOIDC({
				code,
				redirect_uri: REDIRECT_URL,
			})
		);
	}, [dispatch, code, is_logged_in]);

	useEffect(() => {
		if (
			[
				user.is_data_requested,
				is_off_season_with_secret_key_enabled,
			].some(Boolean)
		) {
			return;
		}

		if (
			!history.location.pathname.includes("register-for-game") &&
			user.additional_information_required
		) {
			history.push("/register-for-game");
		}

		if (
			!history.location.pathname.includes("returning-user") &&
			user.should_be_recovered
		) {
			history.push("/returning-user");
		}

		if (!is_logged_in) {
			setIsReady(true);
		} else {
			if (user.id) {
				setIsReady(true);
			}
		}
	}, [is_logged_in, user, history, is_off_season_with_secret_key_enabled]);

	if (!is_ready || user.is_data_requested) {
		return (
			<PreloaderContainer>
				<LoadingSpinner />
			</PreloaderContainer>
		);
	}

	return <div>{children}</div>;
};
